
export function gTag() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(arguments);
};

export function gPageView (page = '/') {
    const loc = window.location || {
        href: page,
        hash: page,
        send_to: 'G-7QBFCN55LZ'
    };
    gTag('set', 'page_path', page);
    gTag('event', 'page_view', {
        page_title: page,
        page_location: loc.href,
        page_path: loc.hash,
        send_to: 'G-7QBFCN55LZ'
    })
};